import React, { useState } from 'react';
import { useAuthAdapter } from '../../hooks/useAuthAdapter';
const GuestBanner = () => {
    const { signIn } = useAuthAdapter();
    const [dismissed, setDismissed] = useState(false);
    if (dismissed)
        return null;
    return (React.createElement("div", { className: "guest-banner", role: "status" },
        React.createElement("span", { className: "guest-banner-text" },
            "You're browsing as a guest \u2014 saved swimmers stay on this device only.",
            ' ',
            React.createElement("strong", null, "Sign in"),
            " to sync across devices."),
        React.createElement("button", { type: "button", className: "guest-banner-signin", onClick: () => { void signIn(); } }, "Sign In"),
        React.createElement("button", { type: "button", className: "guest-banner-dismiss", onClick: () => setDismissed(true), "aria-label": "Dismiss banner" }, "\u00D7")));
};
export default GuestBanner;
